import * as urlTemplate from 'url-template';

import { isNullOrUndefined } from '@app/util/util';
import { SearchData } from '@shared/base-search-bar/entities/search-data';
import { TravelerTypes } from '@pax/entities/traveler-info';
import { Room } from '@shared/base-search-bar/entities/room.entities';
import { FlightClass } from '@shared/base-search-bar/entities/flight-class';
import { FLIGHT_CLASS } from '@search-bar/constants/search-bar.constants';
import { PackageStep } from '@packages/packages-search-bar/constants/package-step';
import { InputDestinationPlace } from '@shared/base-search-bar/entities/autocomplete-destionation';

export const PACKAGE_V2_DIVIDER = '__';

export function mapPackageSearchData(data: SearchData): string {
  return mapTripUrlPackage(data);
}

function mapTripUrlPackage(data: SearchData): string {
  return urlTemplate.
    parse('{flight_class}/{departure}/{destination}/{departure_date}/'
      + '{arrival_date}/{rooms}/{baggageIncluded}/{airline}/{step}')
    .expand({
      flight_class: mapFlightClass(data.flightClass),
      departure: getPlaceParamInfo(data.packageOriginPlace, false),
      destination: getPlaceParamInfo(data.packageDestinationPlace, true),
      departure_date: formatPackageSearchDate(data.departureDate),
      arrival_date: formatPackageSearchDate(data.arrivalDate),
      airline: data.airline ? data.airline : 'null',
      baggageIncluded: data.baggageIncluded,
      rooms: mappedRooms(data.guestsPerRoom),
      step: PackageStep.HOTEL_RESULTS
    });
}

export function mapFlightClass(flightClass: FlightClass): string {
  switch (flightClass) {
    case FlightClass.EXECUTIVE:
      return FLIGHT_CLASS.BUSINESS;
    case FlightClass.CHEAPER:
      return FLIGHT_CLASS.ECONOMY;
    case FlightClass.FIRST_CLASS:
      return FLIGHT_CLASS.FIRST;
    case FlightClass.PREMIUM:
      return FLIGHT_CLASS.PREMIUMECONOMY;
    default:
      return FLIGHT_CLASS.ECONOMY;
  }
}

export function reverseMapFlightClass(classType: string): FlightClass {
  switch (classType) {
    case FLIGHT_CLASS.BUSINESS:
      return FlightClass.EXECUTIVE;
    case FLIGHT_CLASS.ECONOMY:
      return FlightClass.CHEAPER;
    case FLIGHT_CLASS.FIRST:
      return FlightClass.FIRST_CLASS;
    case FLIGHT_CLASS.PREMIUMECONOMY:
      return FlightClass.PREMIUM;
    default:
      return FlightClass.CHEAPER;
  }
}

function mappedRooms(rooms: Room[] = []): string {
  return !isNullOrUndefined(rooms) ? rooms.map(item =>
    `${item[TravelerTypes.ADULTS]}_${item[TravelerTypes.CHILDREN]}_${item.childrenAges.join('_')}`).join('-') : null;
}

export function formatPackageSearchDate(date: Date): string {
  const d = new Date(date);
  let month = `${(d.getUTCMonth() + 1)}`;
  let day = `${d.getUTCDate()}`;
  const year = `${d.getUTCFullYear()}`;

  if (month.length < 2) {
    month = `0${month}`;
  }
  if (day.length < 2) {
    day = `0${day}`;
  }

  return [year, month, day].join('-');
}

export function getPlaceParamInfo(place: InputDestinationPlace, isDestination: boolean): string {
  if (isDestination) {
    if (place?.isPopularSelection || place?.isTravelCitySearch) {
      return `${place?.NearestIata}`;
    } else {
      return place?.NearestIata ?
        `${place?.Id}${PACKAGE_V2_DIVIDER}${place?.InputType}${PACKAGE_V2_DIVIDER}${place?.NearestIata}` :
        `${place?.Id}${PACKAGE_V2_DIVIDER}${place?.InputType}`;
    }
  } else {
    return `${place?.NearestIata}`;
  }
}

export function destinationIsInV2(destinationParam: string): boolean {
  return destinationParam?.split(PACKAGE_V2_DIVIDER)?.length === 3;
}

export function destinationIsHotelV2(destinationParam: string): boolean {
  return destinationParam?.split(PACKAGE_V2_DIVIDER)?.length === 2;
}

export function getDestinationByV2(destinationParam: string): { [key: string]: string } {
  const destination = destinationParam?.split(PACKAGE_V2_DIVIDER);
  if (destinationIsInV2(destinationParam)) {
    return {
      Code: destination?.[2],
      Type: destination?.[1],
      Id: destination?.[0],
    };
  } else if (destinationIsHotelV2(destinationParam)) {
    return {
      Code: '',
      Type: destination?.[1],
      Id: destination?.[0],
    };
  } else {
    return {
      Code: destinationParam
    };
  }
}
